// extracted by mini-css-extract-plugin
export default {"contents":"rF-z","sectionHeading":"sF-z"};